<template>
  <div class="members">
    <team-members-header
      :title="field.value.title"
      :description="field.value.description"
    />

    <div class="main-container main-container-team-members">
      <div class="members-container">
        <team-member
          v-for="(member, index) in field.value.members"
          :key="index"
          ref="member"
          :member="member"
          @opened="closeOthers(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TeamMembersHeader from "/seu-frontend/components/TeamMembersHeader";
import TeamMember from "/seu-frontend/components/TeamMember";

export default {
  name: 'Members',
  components: {TeamMember, TeamMembersHeader},
  props: {
    field: {
      type: Object,
      required: true
    }
  },

  methods: {
    closeOthers(index) {
      this.$refs.member.forEach((m, i) => {
        if(i !== index) {
          m.closeMore();
        }
      })
    }
  }

}
</script>

<style lang="scss">
@import "Members.scss";
</style>
